import qs from 'qs'
import useTable from '../../components/useTable'
import { useFindQuery } from '../../query'
import { ReactText, useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { appRoutes } from '../../containers/Router/routes'
import { Location } from '../../providers/ClientProvider/client/services/locations/types'

const useLocations = () => {
  const { query, onTableChange, currentSort, currentPage } = useTable<Location>()

  const history = useHistory()

  const { data: locationsRes, status } = useFindQuery('locations', query)

  const handleOnRowClick = useCallback((id: string): void => {
    history.push(
      generatePath(appRoutes.locationShow.routes.details.path, {
        id: id
      })
    )
  }, [])

  const onCreateNewLocation = useCallback((): void => {
    history.push(appRoutes.locationCreate.path)
  }, [])

  const handleFilter = useCallback(
    (value: ReactText, dataIndex: string) => {
      query[dataIndex] = { $regex: value, $options: 'ix' }
      history.replace(`${history.location.pathname}?${qs.stringify(query)}`)
    },
    [history, query]
  )

  return {
    locations: locationsRes?.data,
    loading: status === 'loading',
    total: locationsRes?.total || 0,
    onTableChange,
    currentSort,
    currentPage,
    handleOnRowClick,
    onCreateNewLocation,
    handleFilter
  }
}
export default useLocations
